// src/hooks/useAccessGuard.ts
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSubscription } from "../../../../hooks/useSubscription";
import { useAuth } from "../../../../contexts/auth/hooks";

export function useAccessGuard() {
  const { user } = useAuth();
  const location = useLocation();
  const { subscription, trialAvailable, loading } = useSubscription();

  // Check if we're on an external booking page
  const isExternalPage = location.pathname.startsWith('/book/');

  // Access blocking is disabled - users always have access
  const isBlocked = false;

  useEffect(() => {

  }, [loading, user, subscription, trialAvailable, isBlocked]);

  // Always return loading: false since we don't block access anymore
  return {
    isBlocked: false,
    loading: false
  };
}
